module.exports = require("@mui/material/DialogContentText");